import { ApiErrorResponse } from "../../types";
import { convertParamsToQueryString } from "../convertParamsToQueryString";
import { errorIsFromApi } from "../errorIsFromApi";
import { navigateToAdmin } from "../navigateToAdmin";

export async function getRequestWrapper<Params, Response>({
  url,
  params,
}: {
  url: string;
  params?: Params;
}): Promise<Response> {
  const response = await fetch(
    `${url}?${convertParamsToQueryString<Params | undefined>(params)}`,
    {
      credentials: "include",
    }
  );

  if (!response.ok) {
    const error: unknown = await response.json();

    // TODO - Add functionality to detect error type and print error.
    if (errorIsFromApi(error)) {
      const {
        error: { message, code },
      }: ApiErrorResponse = error as ApiErrorResponse;

      console.log(error);

      if (code === -100) {
        // Authentication failed.
        navigateToAdmin();
      }

      throw new Error(`Api Responsed with an error: ${code}: ${message}`);
    }

    throw new Error(`Error encountered when making GET request to "${url}"`);
  }

  return response.json() as Response;
}
